import React, { useEffect, useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import TimezoneSelect from "react-timezone-select";
import {
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../../Redux/action/MasterSkillAction";
import { useStatesByCountry } from "../../../Hooks/useStatesByCountry";
import { useCountries } from "../../../Hooks/useCountries";
import { Button, Form, Modal } from "react-bootstrap";
import { CreateJobFormAction } from "../../../Redux/action/CreateJobFormAction";
import { postLaterApi } from "../../../Services/JobServices";

const CreateJobForm = () => {
  const [startDate, setDate] = useState(new Date());
  const [selectedTimezone, setSelectedTimezone] = useState({
    value: "",
    label: "",
  });
  const [jobLocations, setJobLocations] = useState([]);
  const [daysn, setDaysn] = useState([]);
  const [item, setItem] = useState("");
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [disabled2, setDisabled2] = useState(false);
  const AllSkillList = useSelector(
    (state) => state?.MasterTableDetails?.skill?.content
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedWork, setSelectedWork] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [postLateerModal, setpostLateerModal] = useState(false);
  const [isPostlater, setIsPostlater] = useState(false);
  const [date, setDatePl] = useState("");
  const [time, setTime] = useState("");
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [data, setData] = useState({
    jobTitle: "",
    minimumExperience: "",
    maximumExperience: "",
    requiredSkills: [],
    jobDescription: "",
    workType: "",
    jobType: "",
    workingDays: "",
    workingWeekDays: [],
    shiftTime: "",
    flexibleHours: "",
    validity: "",
    openingTime: "",
    closingTime: "",
    file: null,
    jobsPostedStatus: "",
    country: "",
    state: "",
  });
  const navigate = useNavigate();
  const {
    jobsPostedStatus,
    openingTime,
    closingTime,
    minimumExperience,
    maximumExperience,
    jobTitle,
    country,
    state,
    validity,
    requiredSkills,
    workType,
    jobDescription,
    shiftTime,
    jobType,
    employmentType,
    workingDays,
    flexibleHours,
    workingWeekDays,
  } = data;
  const { data: countriesData, isLoading: countriesLoading } = useCountries();
  const {
    data: stateList,
    isLoading,
    isError,
  } = useStatesByCountry(data?.country || "India");

  const minimumExperiences = minimumExperience;

  let listMin = Array.from({ length: 31 }, (_, i) => i + " years");
  let list = Array.from({ length: 30 }, (_, i) => i + 1 + " years");

  let ListData = [];
  list.map((ndata) => {
    if (minimumExperiences < ndata) {
      ListData.push(ndata);
    }
  });

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setJobLocations(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleChangeDay = (event) => {
    const {
      target: { value },
    } = event;
    setDaysn(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const filesize = file.size / 1024 / 1024;
    if (filesize < 1) {
      setFile(file);
    } else {
      e.target.value = null;
      toast.error("File size should be less than 1MB");
    }
  };

  const handleTimeInputChange = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (name === "requiredSkills") {
      // Split the comma-separated string into an array
      value = value.split(",").map((requiredSkills) => requiredSkills.trim());
    } else if (name === "jobsPostedStatus" && value == "ONHOLD") {
      setData((prev) => ({
        ...prev,
        validity: "",
        [name]: value,
      }));
      return;
    }
    setData({ ...data, [name]: value });
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const MenuPropss = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
        height: 200,
      },
    },
  };
  const defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);
  const { userResult } = useSelector((state) => state.Auth);
  let vendorId = userResult?.vendorid;;

  const dispatch = useDispatch();
  const jobLocation = jobLocations.toString();
  const days = daysn.toString();

  const content = {
    vendorId,
    minimumExperience,
    maximumExperience,
    jobTitle,
    validity,
    requiredSkills,
    workType,
    jobDescription,
    openingTime,
    closingTime,
    jobLocation,
    days,
    shiftTime,
    jobType,
    workingDays,
    flexibleHours,
    jobsPostedStatus,
    workingWeekDays,
    country,
    state,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // --- New Validation: Check shiftTime rules (sameDay/overnight) ---
    const [openingHour, openingMinute] = openingTime.split(":").map(Number);
    const [closingHour, closingMinute] = closingTime.split(":").map(Number);
    if (jobType != "FULL_TIME") {
      if (!openingTime || !closingTime)
        return toast.error("start time and end time is required");
    }
    if (shiftTime === "sameDay") {
      // Same Day: closingTime must be after openingTime
      const closingTimeData =
        Number(closingTime.split(":")[0]) +
        Number(closingTime.split(":")[1] / 60);
      const openingTimeData =
        Number(openingTime.split(":")[0]) +
        Number(openingTime.split(":")[1] / 60);
      if (closingTimeData - openingTimeData < 0.5) {
        toast.error(
          "For same-day shifts, closing time must be min 30 min after opening time."
        );
        return;
      }
    } else {
      // Overnight: closingTime must be earlier (next day)
      if (
        closingHour > openingHour ||
        (closingHour === openingHour && closingMinute > openingMinute)
      ) {
        toast.error(
          "For overnight shifts, closing time must be on the next day (e.g., 23:00 → 07:00)."
        );
        return;
      }
    }
    if (!selectedTimezone?.label) {
      toast.error("Time zone is required");
      return;
    }

    if (parseInt(workingDays) != workingWeekDays.length) {
      toast.error("Working days and working week days must match.");
      return;
    }

    if (parseInt(maximumExperience) <= parseInt(minimumExperience)) {
      toast.error(
        "Maximum experience should be greater than minimum experience."
      );
      return;
    }
    if (isPostlater) {
      setpostLateerModal(true);
      return;
    }

    let newValidity = validity;
    if (data.jobsPostedStatus == "ONHOLD") {
      newValidity = "";
      setDisabled2(true);
    } else if (data.jobsPostedStatus == "POSTED") {
      setDisabled(true);
    }

    // Append jobs data
    const jobsData = {
      vendorId,
      minimumExperience,
      maximumExperience,
      jobTitle,
      validity: newValidity,
      requiredSkills,
      workType,
      jobDescription,
      startTime: openingTime,
      endTime: closingTime,
      jobLocation: (state+", "+country),
      days,
      workingWeekDays,
      shiftTime, // Include shiftTime in payload
      employmentType: jobType,
      workingDays,
      flexibleHours,
      jobsPostedStatus,
      country,
      state,
      timeZone: selectedTimezone.label,
    };

    const formData = new FormData();
    formData.append("jobs", JSON.stringify(jobsData));
    formData.append("file", file);

    // Dispatch API call
    dispatch(CreateJobFormAction(formData, navigate))
      .then((res) => {
        if (res?.data) {
          setTimeout(() => {
            setDisabled(false);
            navigate("/posted_jobs?active=posted")
          }
            , 2000);
        }
      })
      .catch((error) => {
        setDisabled(false)
        setDisabled2(false);
        console.log("reate job error", error);
      });
  };

  const submitPostLater = () => {
    if (!date) return toast.error("Date is required");
    if (!time) return toast.error("Time is required");
    const formData = new FormData();
    const jobsData = {
      vendorId,
      minimumExperience,
      maximumExperience,
      jobTitle,
      validity,
      requiredSkills,
      workType,
      jobDescription,
      startTime: openingTime,
      endTime: closingTime,
      // jobLocation: jobLocations.map((skill) => skill.value).join(", "),
      jobLocation: (state+", "+country),
      days,
      workingWeekDays,
      shiftTime,
      employmentType: jobType,
      workingDays,
      flexibleHours,
      jobsPostedStatus: "POSTLATER",
      timeZone: selectedTimezone.label,
      postLaterDate: date,
      postLaterTime: time,
      state,
      country,
      zoneId: timeZone,
    };
    formData.append("jobs", JSON.stringify(jobsData));
    formData.append("file", file);
    postLaterApi(formData)
      .then((res) => {
        if (res) {
          setTimeout(() => {
            setDisabled(false);
            navigate("/posted_jobs?active=post-later");
          }, 1000);
        }
      })
      .catch((error) => {
        setDisabled(false)
        setDisabled2(false);
        console.log("later job error", error.response.data);
      });
  };

  const options = AllSkillList?.map((item) => ({
    value: item?.skillName,
    label: item?.skillName,
  }));

  const handleSkillsChange = (selectedOptions) => {
    // Update the selected cities in the state
    setSelectedSkills(selectedOptions);
    const selectedValues = selectedOptions.map((option) => option.value);
    setData({ ...data, requiredSkills: selectedValues });
  };

  const WeekOptions = [
    { value: "MONDAY", label: "MONDAY" },
    { value: "TUESDAY", label: "TUESDAY" },
    { value: "WEDNESDAY", label: "WEDNESDAY" },
    { value: "THURSDAY", label: "THURSDAY" },
    { value: "FRIDAY", label: "FRIDAY" },
    { value: "SATURDAY", label: "SATURDAY" },
    { value: "SUNDAY", label: "SUNDAY" },
  ];

  const handleLocationChange = (selectedOptions) => {
    setSelectedLocations(selectedOptions);
    // setData({ ...data, requiredSkills: selectedValues });
    setJobLocations(selectedOptions);
    // Additional logic if needed
  };

  const formatDate = (dateString) => {
    // Implement your date formatting logic here
    // Assuming dateString is in the format yyyy-mm-dd (which is the default HTML date input format)
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    dispatch(fetchSkillDetails());
    dispatch(fetchDesignationDetails());
  }, []);

  const handleDateChange = (inputValue) => {
    // Assuming the input value is in the format dd-mm-yyyy
    const [day, month, year] = inputValue.split("-");
    const formattedDate = `${year}-${month}-${day}`;
    setData({ ...data, validity: formattedDate });
  };

  const arr = [1, 2, 3, 4, 5];

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSkillsChange1 = (selectOption) => {
    setSelectedWork(selectOption);
    const selectValue = selectOption?.map((item) => item.value);
    setData((data) => ({
      ...data,
      workingWeekDays: selectValue,
    }));
  };
  useEffect(() => {
    if (workType === "REMOTE") {
      setData({ ...data, state: "", country: "" });
    }
  }, [workType]);

  useMemo(() => {
    setData({ ...data, state: "" });
  }, [country]);

  const handleClose = () => {
    setpostLateerModal(false);
    setIsPostlater(false);
    setDatePl();
    setTime();
  };
  const formatDateForInput = (str) => {
    const [day, month, year] = str.split("-");
    return `${year}-${month}-${day}`;
  };

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };
  const minDate = getTomorrowDate();
  const maxDate = formatDateForInput(validity);

  useEffect(() => {
    if (jobType == "FULL_TIME") {
      setData({ ...data, shiftTime: "", openingTime: "", closingTime: "" });
    }
  }, [jobType]);

  return (
    <div className="d-flex flex-column flex-md-row gap-4 container mt-4">
      <ToastContainer />
      <div className="can_prof_container">
        <div className="">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="">
              <div className="card can_prof_main">
                <div className="card-header prof_header d-flex justify-content-between">
                  Create New Job
                  {/* <span>
                                        {isDisabled ? <CiEdit onClick={handleEdit} className='pointer' /> : <RiForbid2Line color='red' onClick={handleEdit} className='pointer' />}
                                    </span> */}
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    {/* ... (other educational fields) */}
                    <div className="row gx-3 gy-3 mb-3">
                      {/* Work Type */}
                      <div className="col-12 col-sm-6">
                        <label className="small mb-1" htmlFor="inputWorkType">
                          Work Type
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          className="form-select"
                          id="inputWorkType"
                          name="workType"
                          value={workType}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Work Type</option>
                          <option value="REMOTE">Remote</option>
                          <option value="ONSITE">OnSite</option>
                          <option value="HYBRID">Hybrid</option>
                        </select>
                      </div>

                      {/* Job Title */}
                      <div className="col-12 col-sm-6">
                        <label className="small mb-1" htmlFor="inputInterest">
                          Job Title
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          id="inputInterest"
                          name="jobTitle"
                          value={jobTitle}
                          required
                          onChange={handleInputChange}
                          className="form-select text-truncate"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <option value="" disabled hidden>
                            Select any job title
                          </option>
                          {AllDesignationList?.map((option) => (
                            <option
                              key={option?.designationId}
                              value={option?.designation}
                              title={option?.designation} // Shows full text on hover
                            >
                              {option?.designation}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row gx-3 mb-3">
                      <div className="col-md-3">
                        <label
                          className="small mb-1"
                          htmlFor="inputJobLocations"
                        >
                          Country
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          className="form-select"
                          id="country"
                          name="country"
                          value={country}
                          onChange={handleInputChange}
                          required
                          disabled={workType === "REMOTE"}
                        >
                          <option value="" disabled>
                            select country
                          </option>
                          {countriesData?.data?.map((option) => (
                            <option
                              key={option?.country}
                              value={option?.country}
                            >
                              {" "}
                              {option?.country}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label
                          className="small mb-1"
                          htmlFor="inputJobLocations"
                        >
                          State
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          className="form-select"
                          id="state"
                          name="state"
                          value={state}
                          onChange={handleInputChange}
                          required
                          disabled={workType === "REMOTE"}
                        >
                          <option value="" disabled>
                            select state
                          </option>
                          {stateList &&
                            stateList?.data?.states?.map((option) => (
                              <option key={option?.name} value={option?.name}>
                                {" "}
                                {option?.name}{" "}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="small mb-1" htmlFor="inputMinExp">
                          Min Exp
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          className="form-select"
                          id="inputMinExp"
                          name="minimumExperience"
                          value={minimumExperience}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Min Exp</option>
                          {listMin.map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label className="small mb-1" htmlFor="inputMinExp">
                          Max Exp
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          className="form-select"
                          id="inputMinExp"
                          name="maximumExperience"
                          value={maximumExperience}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Max Exp</option>
                          {list.map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* ... (continue with other form fields) */}
                    <div className="row gx-3 mb-3">
                      <div className="col-12 col-lg-6 col-sm-6">
                        <label className="small mb-1" htmlFor="inputInterest">
                          Job Expiry Date
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <input
                          className="form-control"
                          id="inputInterest"
                          type="date"
                          name="validity"
                          value={formatDate(validity)}
                          onChange={(e) => handleDateChange(e.target.value)}
                          min={minDate}
                          required
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="small mb-1" htmlFor="inputInterest">
                          Job Type
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>

                        <select
                          className="form-select"
                          id="inputWorkType"
                          name="jobType"
                          value={jobType}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="" disabled>
                            Select Job Type
                          </option>
                          <option value="FULL_TIME">Full Time</option>
                          <option value="PART_TIME">Part Time</option>
                          <option value="FLEXIBLE">Flexible Time</option>
                        </select>
                      </div>

                      <div className="col-md-3">
                        <label className="small mb-1" htmlFor="inputInterest">
                          Working Days
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <select
                          className="form-select"
                          id="inputWorkType"
                          name="workingDays"
                          value={workingDays}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="" disabled>
                            Select number of days
                          </option>
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                          <option value={6}>6</option>
                        </select>
                      </div>
                    </div>
                    {(jobType === "PART_TIME" || jobType === "FLEXIBLE") && (
                      <div className="row gx-3 mb-3">
                        <div className="col-md-4">
                          <label className="small mb-1" htmlFor="inputInterest">
                            Shift Type
                            <span
                              style={{ color: "red", paddingLeft: 4 }}
                              className="text-red-700 pl-[2px]"
                            >
                              *
                            </span>
                          </label>
                          <select
                            className="form-select"
                            id="shiftTime"
                            name="shiftTime"
                            value={shiftTime}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="" disabled>
                              Select shift type
                            </option>
                            <option value="sameDay">
                              Same Day (e.g., 09:00 – 17:00)
                            </option>
                            <option value="overnight">
                              Overnight (e.g., 23:00 – 07:00)
                            </option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <label className="small mb-1" htmlFor="inputInterest">
                            Start Time
                            <span
                              style={{ color: "red", paddingLeft: 4 }}
                              className="text-red-700 pl-[2px]"
                            >
                              *
                            </span>
                          </label>
                          <input
                            className="form-control"
                            id="inputInterest"
                            type="time"
                            name="openingTime"
                            placeholder="Enter opening time"
                            value={openingTime}
                            // onChange={handleInputChange}
                            onChange={handleTimeInputChange}
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="small mb-1" htmlFor="inputInterest">
                            End Time
                            <span
                              style={{ color: "red", paddingLeft: 4 }}
                              className="text-red-700 pl-[2px]"
                            >
                              *
                            </span>
                          </label>
                          <input
                            className="form-control"
                            id="inputInterest"
                            type="time"
                            name="closingTime"
                            placeholder="Enter closing time"
                            value={closingTime}
                            // onChange={handleInputChange}
                            onChange={handleTimeInputChange}
                          />
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <label  htmlFor="inputWorkDays">
                          Working Week Days
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <Select
                          autoFocus={false}
                          options={WeekOptions}
                          isClearable={false}
                          isMulti
                          onChange={handleSkillsChange1}
                          value={selectedWork}
                          styles={{
                            multiValue: (styles, { data }) => ({
                              ...styles,
                              backgroundColor: "#286a94",
                            }),
                            multiValueLabel: (styles, { data }) => ({
                              ...styles,
                              color: "white",
                            }),
                            multiValueRemove: (styles, { data }) => ({
                              ...styles,
                              color: "white",
                              ":hover": {
                                backgroundColor: "#1a4b6d",
                                color: "white",
                              },
                            }),
                          }}
                          required
                        />
                      </div>
                       <div className="col-12 col-md-6">
                      Time zone
                      <span
                        style={{ color: "red", paddingLeft: 4 }}
                        className="text-red-700 pl-[2px]"
                      >
                        *
                      </span>
                      <div className="select-wrapper">
                        <TimezoneSelect
                          value={selectedTimezone}
                          onChange={setSelectedTimezone}
                          labelStyle="altName"
                        />
                      </div>
                    </div>
                       <div className="col-12 col-md-12">
                        <label htmlFor="inputOrgName">
                          Skills
                          <span
                            style={{ color: "red", paddingLeft: 4 }}
                            className="text-red-700 pl-[2px]"
                          >
                            *
                          </span>
                        </label>
                        <Select
                          options={options}
                          required={true}
                          isMulti
                          onChange={handleSkillsChange}
                          value={selectedSkills}
                          styles={{
                            multiValue: (styles, { data }) => ({
                              ...styles,
                              backgroundColor: "#286a94",
                            }),
                            multiValueLabel: (styles, { data }) => ({
                              ...styles,
                              color: "white",
                            }),
                            multiValueRemove: (styles, { data }) => ({
                              ...styles,
                              color: "white",
                              ":hover": {
                                backgroundColor: "#1a4b6d",
                                color: "white",
                              },
                            }),
                          }}
                        />
                      </div>
                    </div>

                   
                    <div className="row gx-3 mb-3">
                   
                    </div>
                    <div className="col-md-12 mt-3 mb-3">
                      <label className="small mb-1" htmlFor="inputOrgName">
                        Description
                        <span
                          style={{ color: "red", paddingLeft: 4 }}
                          className="text-red-700 pl-[2px]"
                        >
                          *
                        </span>
                      </label>
                      <textarea
                        className="form-control"
                        id="inputOrgName"
                        // cols={10}
                        rows={7}
                        maxLength={1500}
                        type="text"
                        name="jobDescription"
                        placeholder="Enter Job Description"
                        value={jobDescription}
                        onChange={handleInputChange}
                        required
                        // disabled={isDisabled}
                      />
                    </div>
                    <div className="row gx-3 mb-3">
                      <div className="col-12 col-lg-12">
                        <label className="small mb-1" htmlFor="vendorEmailId">
                          Upload Assignment
                        </label>
                        <input
                          className="form-control"
                          id="vendorEmailId"
                          type="file"
                          name="file"
                          accept="application/pdf, image/*"
                          onChange={handleFileChange}
                        />
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 10 ,flexWrap:"wrap"}}>
                      <button
                        disabled={disabled}
                        className="can_update_prof_btn add_skill_btn"
                        onClick={() =>
                          setData({ ...data, jobsPostedStatus: "POSTED" })
                        }
                      >
                        {disabled ? "Loading" : "Post Job"}
                      </button>
                      <button
                        disabled={disabled2}
                        className="can_update_prof_btn add_skill_btn"
                        onClick={() =>
                          setData({ ...data, jobsPostedStatus: "ONHOLD" })
                        }
                      >
                        {disabled2 ? "Loading" : "Save as Draft"}
                      </button>
                      <button
                        onClick={() => setIsPostlater(true)}
                        className="can_update_prof_btn add_skill_btn"
                      >
                        Post Later
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="jc_notes_container p-3 mb-3">
        <p className="jc_notes_head">Important Notes!</p>
        <div className="line_divide"></div>
        <div className="jc_notes mt-3">
          <p>
            AI That Understands Hiring: eBench uses intelligent algorithms to
            match you with the right candidates—fast, accurately, and with zero
            guesswork.
          </p>
          <p>
            Vetted Professionals Only: Every candidate is thoroughly assessed
            for skills, experience, and fit—saving you time and ensuring
            quality.
          </p>
          <p>
            All-in-One Hiring Platform: Post jobs, manage candidates, schedule
            interviews, and onboard—all from one intuitive dashboard.
          </p>
          <p>
            Reduce Time & Cost: Cut hiring time by up to 70% and avoid the costs
            of bad hires with data-backed decision-making.
          </p>
          <p>
            Global Reach, Local Compliance: Find top remote talent while
            ensuring full compliance with employment laws across regions.
          </p>
          <p>
            Custom Workflows: Tailor the platform for every industry and
            internal hiring processes—whether you're a startup or a large
            enterprise.
          </p>
        </div>
      </div>
      <Modal
        show={postLateerModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        style={{ top: "20%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Post Later </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="postDate" className="mb-3">
              <Form.Label>Select Date</Form.Label>
              <Form.Control
                type="date"
                value={date}
                onChange={(e) => setDatePl(e.target.value)}
                min={minDate}
                max={maxDate}
              />
            </Form.Group>
            <Form.Group controlId="postTime" className="mb-3">
              <Form.Label>Select Time</Form.Label>
              <Form.Control
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
          className="flex-center"
          style={{ justifyContent: "center" }}
        >
          <Button
            variant="success"
            onClick={() => {
              setIsPostlater(false);
              submitPostLater();
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateJobForm;
